








import { Component, Prop, Vue } from 'vue-property-decorator';

import * as def from '@/definitions'
import { Design } from '@/model/document2/page/surface/design/design';
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { Vector2 } from '@/utilityModels/vector2';
import { UuidHelper } from '@/helper/uuidHelper';
import { UserAgentHelper } from '@/helper/userAgentHelper';
import { MathHelper } from '@/helper/mathHelper';
import { DebugHelper } from '@/helper/debugHelper';

@Component({
    components: {
    },
})

// スマートガイド
export default class SmartGuide extends Vue 
{
    @Prop() private design! : Design;
    @Prop() private layer! : Layer | null;
    @Prop() private scale! : number;
    @Prop() private offsetX! : number;
    @Prop() private offsetY! : number;

    // ガイドラインのはみ出し(mm)
    private static readonly GUIDE_LINE_OVER_LENGTH = 5.0;
    
    // ガイド情報
    private get guideInfoArray() : Array<{x1 : number, y1 : number, x2 : number, y2 : number}> 
    {
        var array : Array<{x1 : number, y1 : number, x2 : number, y2 : number}> = new Array();

        if(this.layer == null) { return array; }

        // 外接矩形取得
        var bounds = this.layer.getBoundingRect();

        // 12点の初期位置
        var toplx = bounds.x;
        var toply = bounds.y;
        var btmlx = bounds.x;
        var btmly = bounds.y + bounds.height;
        var btmrx = bounds.x + bounds.width;
        var btmry = bounds.y + bounds.height;
        var toprx = bounds.x + bounds.width;
        var topry = bounds.y;
        var centerl = bounds.x;
        var centert = bounds.y;
        var centerr = bounds.x + bounds.width;
        var centerb = bounds.y + bounds.height;
        
        // ライン表示フラグ
        var isLineLeft = false;
        var isLineTop = false;
        var isLineRight = false;
        var isLineBottom = false;
        var isLineCenterVertical = false;
        var isLineCenterHorizontal = false;

        // 全レイヤー取得
        var allLayers = this.design.getAllLayers(false);
        for(var i = 0; i < allLayers.length; ++i)
        {
            var targetLayer = allLayers[i];
            if(targetLayer == this.layer) { continue; }

            // 外接矩形取得
            var targetBounds = targetLayer.getBoundingRect();
            if(MathHelper.equalsWithError(bounds.x, targetBounds.x) || MathHelper.equalsWithError(bounds.x, targetBounds.x + targetBounds.width))
            {
                // 左ライン表示
                isLineLeft = true;
                if(targetBounds.y < toply) { toply = targetBounds.y; }
                if(targetBounds.y + targetBounds.height > btmly) { btmly = targetBounds.y + targetBounds.height; }
            }
            if(MathHelper.equalsWithError(bounds.y, targetBounds.y) || MathHelper.equalsWithError(bounds.y, targetBounds.y + targetBounds.height))
            {
                // 上ライン表示
                isLineTop = true;
                if(targetBounds.x < toplx) { toplx = targetBounds.x; }
                if(targetBounds.x + targetBounds.width > toprx) { toprx = targetBounds.x + targetBounds.width; }
            }
            if(MathHelper.equalsWithError(bounds.x + bounds.width, targetBounds.x) || MathHelper.equalsWithError(bounds.x + bounds.width, targetBounds.x + targetBounds.width))
            {
                // 右ライン表示
                isLineRight = true;
                if(targetBounds.y < topry) { topry = targetBounds.y; }
                if(targetBounds.y + targetBounds.height > btmry) { btmry = targetBounds.y + targetBounds.height; }
            }
            if(MathHelper.equalsWithError(bounds.y + bounds.height, targetBounds.y) || MathHelper.equalsWithError(bounds.y + bounds.height, targetBounds.y + targetBounds.height))
            {
                // 下ライン表示
                isLineBottom = true;
                if(targetBounds.x < btmlx) { btmlx = targetBounds.x; }
                if(targetBounds.x + targetBounds.width > btmrx) { btmrx = targetBounds.x + targetBounds.width; }
            }
            if(MathHelper.equalsWithError(bounds.x + bounds.width / 2, targetBounds.x + targetBounds.width / 2))
            {
                // 中央縦ライン表示
                isLineCenterVertical = true;
                if(targetBounds.y < centert) { centert = targetBounds.y; }
                if(targetBounds.y + targetBounds.height > centerb) { centerb = targetBounds.y + targetBounds.height; }
            }
            if(MathHelper.equalsWithError(bounds.y + bounds.height / 2, targetBounds.y + targetBounds.height / 2))
            {
                // 中央横ライン表示
                isLineCenterHorizontal = true;
                if(targetBounds.x < centerl) { centerl = targetBounds.x; }
                if(targetBounds.x + targetBounds.width > centerr) { centerr = targetBounds.x + targetBounds.width; }
            }
        }

        var over = SmartGuide.GUIDE_LINE_OVER_LENGTH;

        if(isLineLeft)
        {
            // 左ライン描画
            array.push({ x1 : bounds.x, y1 : toply - over, x2 : bounds.x, y2 : btmly + over });
        }
        if(isLineTop)
        {
            // 上ライン描画
            array.push({ x1 : toplx - over, y1 : bounds.y, x2 : toprx + over, y2 : bounds.y });
        }
        if(isLineRight)
        {
            // 右ライン描画
            array.push({ x1 : bounds.x + bounds.width, y1: topry - over, x2 : bounds.x + bounds.width, y2 : btmry + over });
        }
        if(isLineBottom)
        {
            // 下ライン描画
            array.push({ x1 : btmlx - over, y1 : bounds.y + bounds.height, x2 : btmrx + over, y2 : bounds.y + bounds.height });
        }
        if(isLineCenterVertical)
        {
            // 中央縦ライン描画
            array.push({ x1 : bounds.x + bounds.width / 2, y1 : centert - over, x2 : bounds.x + bounds.width / 2, y2 : centerb + over });
        }
        if(isLineCenterHorizontal)
        {
            // 中央横ライン描画
            array.push({ x1 : centerl - over, y1 : bounds.y + bounds.height / 2, x2 : centerr + over, y2 : bounds.y + bounds.height / 2 });
        }

        // すべての値をスケーリング、オフセット
        for(var i = 0; i < array.length; ++i)
        {
            array[i].x1 = array[i].x1 * this.scale + this.offsetX;
            array[i].y1 = array[i].y1 * this.scale + this.offsetY;
            array[i].x2 = array[i].x2 * this.scale + this.offsetX;
            array[i].y2 = array[i].y2 * this.scale + this.offsetY;
        }

        return array;
    }

}
